<div fxLayout="row wrap">
    <div fxFlex="100" fxFlex.gt-md="45" fxFlex.md="45">

        <mat-card class="product-image">
            <button mat-icon-button (click)="openZoomViewer()" fxHide="false" fxHide.gt-md>
                <mat-icon>fullscreen</mat-icon>
            </button>
            <img *ngIf="image" [src]="image" (mousemove)="onMouseMove($event)" (mouseleave)="onMouseLeave($event)" />
        </mat-card>

        <div class="small-carousel">
            <div class="swiper-container" [swiper]="config">
                <div class="swiper-wrapper">
                    <div *ngFor="let image of product?.productImages" class="swiper-slide">
                        <mat-card (click)="selectImage(image)" class="p-1">
                            <img [attr.data-src]="image.imageUrl" class="swiper-lazy" />
                            <div class="swiper-lazy-preloader"></div>
                        </mat-card>
                    </div>
                </div>
                <button mat-icon-button class="swiper-button-prev swipe-arrow">
                    <mat-icon>keyboard_arrow_left</mat-icon>
                </button>
                <button mat-icon-button class="swiper-button-next swipe-arrow">
                    <mat-icon>keyboard_arrow_right</mat-icon>
                </button>
            </div>
        </div>
    </div>
    <div fxFlex="100" fxFlex.gt-md="55" fxFlex.md="55" ngClass.gt-sm="px-3 m-0" ngClass.sm="mt-2" ngClass.xs="mt-2">
        <div #zoomViewer fxShow="false" fxShow.gt-md>
            <mat-card *ngIf="zoomImage" class="zoom-viewer mat-elevation-z18"
                [ngStyle]="{'background-image': 'url(' + zoomImage + ')'}"></mat-card>
        </div>
        <h2>{{product?.productName}}</h2>
        <div class="py-1 lh">
            <p><span class="text-muted fw-500">Availibility: </span><span>{{ (product?.availibilityCount > 0) ? 'In
                    stock':'Unavailable'}}</span></p>
        </div>
        <div class="py-1">
        </div>
        <p class="py-1 text-muted lh">{{product?.productDetails}}</p>
        <div class="divider mt-1"></div>
        <div class="py-2">
            <h2 class="new-price">Rs.{{product?.productPrice}}</h2>
            <h3 style="font-size:16px;color:red">Applicable Tax.{{product?.cgst}} %</h3>
        </div>
       
        <div class="py-1" style="width:40%">
            <app-controls [product]="product" [type]="'all'"></app-controls>
        </div>
        <div class="divider"></div>
    </div>
</div>

<div fxLayout="row wrap" class="mt-2">
    <div fxFlex="100" fxFlex.gt-md="100" fxFlex.md="74">
        <mat-card>
            <mat-tab-group [@.disabled]="true" [selectedIndex]="0">
                <mat-tab label="Specification">
                    <div class="full-desc lh">
                        <ejs-richtexteditor #toolsRTE [toolbarSettings]='tools' id="productSpecification"
                            value="{{product?.productSpecification}}" placeholder="Specification">
                        </ejs-richtexteditor>
                    </div>
                </mat-tab>
                <mat-tab label="Services & Parts">
                    <div class="mat-table admin-table">
                        <div class="mat-header-row">
                            <div class="mat-header-cell">Title</div>
                            <div class="mat-header-cell">File Name</div>

                        </div>
                        <div class="mat-row " *ngFor="let service of manuals">
                            <div class="mat-cell">{{service.serviceManualTitle}}
                            </div>
                            <div class="mat-cell"> <a href="{{service.serviceManual}}">
                                    <img class="file-download" src="../../../../assets/images/file-download.png" />
                                </a></div>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Training Material">
                    <div class="mat-table admin-table">
                        <div class="mat-header-row">
                            <div class="mat-header-cell">Title</div>
                            <div class="mat-header-cell">File Name</div>

                        </div>
                        <div class="mat-row " *ngFor="let training of trainings">
                            <div class="mat-cell">{{training.trainingTitle}} 
                            </div>
                            <div class="mat-cell"> <a href="{{training.trainingLink}}">
                                    <img class="file-download" src="../../../../assets/images/file-download.png" />
                                </a></div>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Video">
                    <div class="full-desc lh">

                        <div fxLayout="row wrap" class="mt-2">
                            <div fxFlex="100" fxFlex.gt-sm="100">
                                <mat-card>
                                    <div class="player-wrapper" *ngIf="currentItem!=undefined">
                                        <vg-player (onPlayerReady)="onPlayerReady($event)">
                                            <vg-overlay-play></vg-overlay-play>
                                            <vg-buffering></vg-buffering>
                                            <vg-scrub-bar>
                                                <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
                                                <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
                                            </vg-scrub-bar>
                                            <vg-controls>
                                                <vg-play-pause></vg-play-pause>
                                                <vg-playback-button></vg-playback-button>
                                                <vg-time-display vgProperty="current" vgFormat="mm:ss">
                                                </vg-time-display>
                                                <vg-time-display vgProperty="total" vgFormat="mm:ss"></vg-time-display>
                                                <vg-mute></vg-mute>
                                                <vg-volume></vg-volume>
                                                <vg-fullscreen></vg-fullscreen>
                                            </vg-controls>
                                            <video #media [vgMedia]="media" [src]="currentItem.videoLink"
                                                id="singleVideo" preload="auto" crossorigin>
                                            </video>
                                        </vg-player>
                                        <ul>
                                            <li class="playlist-item" *ngFor="let item of videos; let $index = index"
                                                (click)="onClickPlaylistItem(item, $index)"
                                                [class.selected]="item === currentItem">
                                                {{ item.videoTitle }}
                                            </li>
                                        </ul>
                                    </div>

                                </mat-card>
                            </div>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </mat-card>
    </div>
</div>